import {Asset} from "@core/model";
import {IconButton, Stack, Typography} from "@mui/material";
import {renderAssetTypeIcon, truncateSx} from "@util";
import {
  CheckBoxOutlineBlankOutlined,
  CheckBoxOutlined,
} from "@mui/icons-material";

const AssetRow = ({
  asset,
  level,
  selection,
  onSelect,
}: {
  asset: Asset;
  level: number;
  selection: string[];
  onSelect: (asset: string) => void;
}) => {
  const ml = level > 0 ? 2 : 0;
  const selected = selection.indexOf(asset.id) !== -1;

  return (
    <Stack ml={ml} my={"2px"}>
      <Stack
        direction={"row"}
        alignItems={"center"}
        position={"relative"}
        sx={{cursor: "pointer"}}
        py={0.5}>
        <Stack
          flex={2}
          gap={1}
          direction={"row"}
          alignItems={"center"}
          onClick={() => onSelect(asset.id)}>
          <IconButton size="small">
            {selected ? (
              <CheckBoxOutlined fontSize="small" />
            ) : (
              <CheckBoxOutlineBlankOutlined fontSize="small" />
            )}
          </IconButton>
          {renderAssetTypeIcon(asset.type)}
          <Typography variant="body2" sx={{...truncateSx}}>
            {asset.name}
          </Typography>
        </Stack>
      </Stack>
      {asset.children?.map(c => (
        <AssetRow
          key={c.id}
          asset={c}
          level={level + 1}
          onSelect={onSelect}
          selection={selection}
        />
      ))}
    </Stack>
  );
};

export {AssetRow};
